import gsap from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { Basics } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';

gsap.registerPlugin(DrawSVGPlugin);

export class Icon {
  dom;
  icons;
  direction = 1;

  _calls = {
    show: () => this.show(),
    hide: () => this.hide()
  }

  constructor(dom) {
    this.dom = dom;
    this.icons = [...GetBy.selector('svg', dom)];

    if (this.icons.length) {
      dom.addEventListener(Basics.mouseOver, this._calls.show);
      dom.addEventListener(Basics.mouseOut, this._calls.hide);
      this.direction = dom.hasAttribute('scroll-slider-next') ? 1 : -1;
    }
  }

  show() {
    gsap.set(this.icons, { x: '0%' });
    gsap.to(this.icons, {
      x: this.direction * 100 + '%',
      stagger: 0.01,
      duration: 0.3,
      ease: 'power3.inOut'
    });
  }

  hide() { }

  resize() { }

  dispose() {
    if (this.icons.length) {
      this.dom.removeEventListener(Basics.mouseOver, this._calls.show);
      this.dom.removeEventListener(Basics.mouseOut, this._calls.hide);
    }

    gsap.killTweensOf(this.dom);
    gsap.killTweensOf(this.icons);
    gsap.set(this.dom, { clearProps: 'all' });
    gsap.set(this.icons, { clearProps: 'all' });
  }
}
